import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ComfortableSkills, ExpertiseSkills, FamiliarSkilks, ToolsSkills } from '../../Fakedata/skill';
import './skill.css'

const Skill = () => {
    const [selectedSkill, setSelectedSkill] = useState(ExpertiseSkills)
    let expertActive
    let toolsActive
    let familiarActive
    let comfortActive

    if (selectedSkill == ExpertiseSkills) {
        expertActive = {
            color: "black",
            backgroundColor: "#64ffda",
            border: "1px solid #64ffda",
        }
    }
    if (selectedSkill == FamiliarSkilks) {
        familiarActive = {
            color: "black",
            backgroundColor: "#64ffda",
            border: "1px solid #64ffda",
        }
    }
    if (selectedSkill == ComfortableSkills) {
        comfortActive = {
            color: "black",
            backgroundColor: "#64ffda",
            border: "1px solid #64ffda",
        }
    }
    if (selectedSkill == ToolsSkills) {
        toolsActive = {
            color: "black",
            backgroundColor: "#64ffda",
            border: "1px solid #64ffda",
        }
    }
    
    return (
        <Container>
            <div className="skill-section my-5">
                <div align="center" md={12} className="skill-details mt-5">
                    <h2 className="section-title mb-4">My Skills</h2>
                    <div className="skillFilter mb-3">
                        {/* <li onClick={()=>setSelectedSkill('all')}>All</li> */}
                        <li style={expertActive} onClick={() => setSelectedSkill(ExpertiseSkills)}>Expertise</li>
                        <li style={comfortActive} onClick={() => setSelectedSkill(ComfortableSkills)}>Comfortable</li>
                        <li style={familiarActive} onClick={() => setSelectedSkill(FamiliarSkilks)}>Familiar</li>
                        <li style={toolsActive} onClick={() => setSelectedSkill(ToolsSkills)}>Tools</li>
                    </div>
                    <div className="allSkills">
                        <Row align="center">
                            {
                                selectedSkill.map((sk, index) => <Col align="center" className="p-3 m-0 " xs={6} sm={6} md={3} ><div className="singleSkill py-ex-4 py-md-5 m-0" >{sk}</div> </Col>)

                            }
                        </Row>

                    </div>
                </div>
            </div>
        </Container>

    );
};

export default Skill;